import { useRef } from "react";

// Props that make a field select its whole value whenever it gains focus --
// by Tab, by the grid's arrow keys, or by a click.
//
// Hours is the one field on the grid where arriving should highlight: a saved
// line holds "0.00", and the owner was backspacing the zeros out before every
// figure. Selected, the first digit typed simply replaces it.
//
// select() in onFocus is enough for keyboard arrival. A click is different:
// focus fires on mousedown, and the browser then places the caret on mouseup,
// which in Safari (and Chrome, intermittently) collapses the selection we just
// made. So the mouseup that belongs to the focusing click is swallowed --
// only that one. Any later click in the already-focused field, or a drag to
// select part of the value, behaves normally.
export default function useSelectOnFocus() {
  const justFocused = useRef(false);
  return {
    onFocus: (e) => {
      justFocused.current = true;
      e.target.select();
    },
    onMouseUp: (e) => {
      if (justFocused.current) e.preventDefault();
      justFocused.current = false;
    },
    // A keyboard arrival has no mouseup coming; drop the flag on the first
    // key so a later click still places the caret.
    onKeyDown: () => { justFocused.current = false; },
    onBlur: () => { justFocused.current = false; },
  };
}
